import { useAuth } from "@clerk/clerk-react";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ProtectedRoute = ({ children }) => {
  const { getToken, isLoaded, isSignedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isLoaded) return;

    if (!isSignedIn) {
      navigate("/");
      return;
    }

    const verify = async () => {
      try {
        const token = await getToken();
        const res = await axios.get(`${API_URL}/api/auth/me`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        
        const backendUser = res.data;
        const isMasterAdmin = backendUser.email === "utkarsh0907.edu@gmail.com";

        if (location.pathname !== "/setup") {
          if (backendUser.role === "admin" || isMasterAdmin) {
            setLoading(false);
          } else if (backendUser.role && !backendUser.is_approved) {
            navigate("/setup");
          } else {
            setLoading(false);
          }
        } else {
          setLoading(false);
        }
      } catch {
        navigate("/");
      }
    };

    verify();
  }, [isLoaded, isSignedIn, getToken, navigate, location.pathname]);


  if (loading) {
    return <div>Loading...</div>;
  }

  return children;
};

export default ProtectedRoute;
